module.exports = __webpack_public_path__ + "static/media/icon_3.4f09dc79.png";